<template>
  <path
    d="M12.0001 17.2702L17.1701 20.3902C17.5501 20.6202 18.0201 20.2802 17.9201 19.8502L16.5501 13.9702L21.1101 10.0202C21.4401 9.73019 21.2701 9.18018 20.8201 9.14018L14.8101 8.63018L12.4601 3.09018C12.2901 2.68018 11.7101 2.68018 11.5401 3.09018L9.19006 8.63018L3.18006 9.14018C2.74006 9.18018 2.56006 9.73019 2.90006 10.0202L7.46006 13.9702L6.09006 19.8502C5.99006 20.2802 6.46006 20.6202 6.84006 20.3902L12.0001 17.2702Z"
  />
</template>
